var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('address-book-edit-popup')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }